$(document).ready(function () {
  // Add active class to inputs
  $(".add-to-cart-quantity-inputs input").click(function () {
    $(".add-to-cart-quantity-inputs input").removeClass("active-input");
    $(this).addClass("active-input");
  });

  $(".add-to-cart-quantity-inputs input").on("input", function () {
    // Variables
    $(".total-num-text").text("");
    var unitPrice = $(this).attr("data-unitprice") / 100;

    // Check for box product
    if (
      $(".add-to-cart-quantity-inputs .add-to-cart-quantity-input-boxes").length
    ) {
      var tilecal = parseFloat(
        $(
          ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-boxes"
        ).attr("data-tilecalc")
      );

      // Check for class
      if ($(this).hasClass("add-to-cart-quantity-input-m2")) {
        // Function
        if ($.cookie("cart_currency") === "USD") {
          $(
            ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-boxes"
          ).val(Math.ceil(($(this).val() / 10.764) * tilecal));
        } else {
          $(
            ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-boxes"
          ).val(Math.ceil($(this).val() / tilecal));
        }
      } else if ($(this).hasClass("add-to-cart-quantity-input-boxes")) {
        console.log("Cookie cart curr (boxes): ", $.cookie("cart_currency"));
        if ($.cookie("cart_currency") === "USD") {
          $(".add-to-cart-quantity-input-m2").val(
            parseFloat($(this).val() * (tilecal * 10.764)).toFixed(2)
          );
        } else {
          $(".add-to-cart-quantity-input-m2").val(
            parseFloat($(this).val() * tilecal).toFixed(2)
          );
        }
      }

      var quantity = $(
        ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-boxes"
      ).val();

      var price = (quantity * unitPrice).toFixed(2);
      // var price = (quantity * (unitPrice * 1.2)).toFixed(2);

      checkQuantity(quantity, true, false); // was passing unused 'true'
      $(this).removeClass("active-input");
      $(".add-to-cart-quantity-input-boxes").addClass("active-input");
    } else {
      // Variables
      var multiplier = parseFloat(
        $(".add-to-cart-quantity-inputs .add-to-cart-quantity-input-m2").attr(
          "data-multiplier"
        )
      );

      if ($(this).hasClass("add-to-cart-quantity-input-m2")) {
        console.log("Cookie cart curr (m2): ", $.cookie("cart_currency"));
        if ($.cookie("cart_currency") === "USD") {
          $(
            ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-tiles"
          ).val(Math.ceil($(this).val() * multiplier));
          var price = (
            unitPrice *
            parseInt(
              $(
                ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-tiles"
              ).val()
            )
          ).toFixed(2);
        } else {
          $(
            ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-tiles"
          ).val(Math.ceil($(this).val() * multiplier));
          var price = (
            unitPrice *
            parseInt(
              $(
                ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-tiles"
              ).val()
            ) * 1.2
          )
            // * 1.2
            .toFixed(2);
        }
      } else {
        var quantity = $(
          ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-tiles"
        ).val();
        console.log("Cookie cart curr (tiles): ", $.cookie("cart_currency"));
        if ($.cookie("cart_currency") === "USD") {
          $(".add-to-cart-quantity-input-m2").val(
            Math.ceil((quantity / multiplier)) + " sq ft"
          );
          if (quantity) {
            var price = (unitPrice * parseInt($(this).val())).toFixed(2);
          } else {
            var price = 0;
          }
        } else {
          $(".add-to-cart-quantity-input-m2").val(
            (quantity / multiplier).toFixed(2) + " m2"
          );
          if (quantity) {
            var price = (unitPrice * parseInt($(this).val())).toFixed(
              // * 1.2
              2
            );
          } else {
            var price = 0;
          }
        }
      }

      // Variables
      var quantity = $(
        ".add-to-cart-quantity-inputs .add-to-cart-quantity-input-tiles"
      ).val();
      checkQuantity(parseInt(quantity), false);
    }

    var unitCurrency = $(this).attr("data-unitcurrency");
    $(".total-num-text").text(unitCurrency + price);
  });

  var checkQuantity = function (quantity, tmp2 = false, ft2 = false) {
    let mtoText = $(".mto-text");
    let leadtime = $("#lead-time").length ? $("#lead-time").val() : "6-8 weeks";
    // const custom_unit_text = $(".stock-text").data('customunit');
    // const is_lot = custom_unit_text.includes('Lot');
    if (quantity > 0) {
      if (tmp2) {
        if ($(".stockCount").text().length > 0) {
          var inStock = ft2
            ? (
                parseInt($(".stockCount").text()) /
                Math.ceil(
                  parseInt(
                    $(".add-to-cart-quantity-input-m2").attr("data-multiplier")
                  ) / 10.764
                )
              ).toFixed(2)
            : (
                parseInt($(".stockCount").text()) /
                parseInt(
                  $(".add-to-cart-quantity-input-m2").attr("data-multiplier")
                )
              ).toFixed(2);
        } else {
          var inStock = 0;
        }

        if (
          inStock <= 0 ||
          $("#is_available").val() === "false" ||
          $(".stockCount").text().length === 0
        ) {
          inStock = 0;
          var text = $(".is_reclaimed").length
            ? "We have " +
              inStock +
              " in stock, if you're looking for more please browse our entire <a href='/collections/reclaimed-tiles'>Reclaimed Collection</a>"
              // Reclaimed out of stock
            : "This product is made to order, the lead time is " +
              leadtime +
              ".";
              // MTO - out of stock
        } else {
          var text = $(".is_reclaimed").length
            ? "We have " +
              inStock +
              " in stock, if you're looking for more please browse our entire <a href='/collections/reclaimed-tiles'>Reclaimed Collection</a>"
              // Reclaimed - in stock
            : "You can order " +
              inStock +
              (ft2 ? "ft<sup>2</sup>" : "m<sup>2</sup>") +
              " today, or wait <strong>" +
              leadtime +
              "</strong> for the complete order of " +
              quantity +
              (ft2 ? "ft<sup>2</sup>" : "m<sup>2</sup>");
              // ?
        }
        mtoText.html(text);
      } else {
        if ($(".stockCount").text().length > 0) {
          var inStock = parseInt($(".stockCount").text());
        } else {
          var inStock = 0;
        }

        if (
          inStock <= 0 ||
          $("#is_available").val() === "false" ||
          $(".stockCount").text().length === 0
        ) {
          inStock = 0;
          var text = $(".is_reclaimed").length
            ? "We have " +
              inStock +
              " in stock, if you're looking for more please browse our entire <a href='/collections/reclaimed-tiles'>Collection</a>"
              // Reclaimed out of stock
            : "This product is handcrafted especially for you, and will be available for delivery in " + leadtime;
              // MTO - out of stock
        } else {
          var text = $(".is_reclaimed").length
            ? "We have " +
              inStock +
              " in stock, if you're looking for more please browse our entire <a href='/collections/reclaimed-tiles'>Collection</a>"
              // Reclaimed tiles - in stock
            : "There is only one lot of this product available. If you would like to order more than available, please contact <a href='mailto:design@bertandmay.com' target='_blank'>design@bertandmay.com</a>";
              // "You can order " +
              // inStock +
              // " today, or wait <strong>" +
              // leadtime +
              // "</strong> for the complete order of " +
              // quantity +
              // " units";
              // Lot - in stock
        }
        mtoText.html(text);
      }

      if (parseInt(quantity) > parseInt(inStock)) {
        $(".add-to-cart-cta").css("height", "auto");
        $(".cta-buttons-wrapper").css("height", "auto");
        mtoText.show();
      } else {
        $(".add-to-cart-cta").css("height", "207px");
        $(".cta-buttons-wrapper").css("height", "162px");
        mtoText.hide();
      }
    } else {
      mtoText.hide();
    }
  };
});